// extracted by mini-css-extract-plugin
export default {"content":"app_content__Hk8T+"};